import { NavLink, Outlet } from "react-router-dom";
import { CalendarDays, CalendarOff, LogOut, MessageSquare, QrCode } from "lucide-react";
import { useUnread } from "@/components/Chat";
import { useAuth } from "@/lib/auth";
import { BrandLogo } from "@/components/Brand";
import { TrackingAgent } from "@/components/TrackingAgent";
import { TechOnboarding } from "@/components/TechOnboarding";
import { NotificationGate } from "@/components/NotificationGate";
import { PasswordChangeGate } from "@/components/PasswordChangeGate";

const Tab = ({ to, end, Icon, label, id, badge }) => (
  <NavLink to={to} end={end} data-testid={`tech-tab-${id}`}
    className={({ isActive }) => `relative flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-semibold transition-colors ${isActive ? "text-[#61a229]" : "text-slate-400"}`}>
    <Icon className="h-5 w-5" /> {label}
    {badge > 0 && <span className="absolute right-[30%] top-1.5 rounded-full bg-red-500 px-1.5 text-[10px] font-bold text-white" data-testid={`tech-tab-${id}-badge`}>{badge}</span>}
  </NavLink>
);

export default function TechLayout() {
  const { user, logout } = useAuth();
  const unread = useUnread();
  return (
    <div className="min-h-screen bg-slate-100">
      <div className="mx-auto min-h-screen max-w-md bg-[#f8faf5] pb-24 shadow-xl">
        <header className="sticky top-0 z-30 flex items-center justify-between border-b bg-white/90 px-4 py-3 backdrop-blur-md">
          <BrandLogo to="/tecnico" />
          {(user?.role === "responsabile" || user?.admin_power) && <a href="/admin" className="text-xs font-semibold text-[#61a229]" data-testid="tech-office-link">Area ufficio</a>}
          <button onClick={logout} className="flex items-center gap-1.5 text-xs text-slate-500" data-testid="tech-logout-button">
            <span className="max-w-[110px] truncate">{user?.name}</span><LogOut className="h-4 w-4" />
          </button>
        </header>
        <main className="px-4 pt-5"><PasswordChangeGate><TechOnboarding><NotificationGate /><TrackingAgent /><Outlet /></TechOnboarding></PasswordChangeGate></main>
        <nav className="fixed bottom-0 left-1/2 z-30 flex w-full max-w-md -translate-x-1/2 border-t bg-white/95 backdrop-blur-md pb-[env(safe-area-inset-bottom)]">
          <Tab to="/tecnico" end Icon={CalendarDays} label="Agenda" id="agenda" />
          {user?.employment !== "autonomo" && <Tab to="/tecnico/timbra" Icon={QrCode} label="Timbra" id="punch" />}
          <Tab to="/tecnico/messaggi" Icon={MessageSquare} label="Messaggi" id="messages" badge={unread} />
          <Tab to="/tecnico/assenze" Icon={CalendarOff} label="Assenze" id="absences" />
        </nav>
      </div>
    </div>
  );
}
